/** Device-local calendar helpers. Adapters read the wall clock only through an injected `now`. */

const pad = (n: number) => n.toString().padStart(2, '0');

/** 'YYYY-MM-DD' of an epoch-ms instant in the device's time zone. */
export function localDayKey(ms: number): string {
  const d = new Date(ms);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Minutes since local midnight (0..1439). */
export function localMinutes(ms: number): number {
  const d = new Date(ms);
  return d.getHours() * 60 + d.getMinutes();
}

export type Clock = () => number;
export const systemClock: Clock = () => Date.now();
